export default __webpack_public_path__ + "static/media/submitted_islamic.ee00fa39.gif";